import { Card, CardContent, Grid, TextField } from '@mui/material';
import MWUploader from 'components/MWUploader';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'reduxStore/hooks';
import { addPatientDataDetails } from 'reduxStore/patientDataDetails/addPatientDataDetails/addPatientDataDetailsSlice';
import { AddPatientDataDetailsBody } from 'reduxStore/patientDataDetails/addPatientDataDetails/Model';
export default function ParentPANCard() {
  const dispatch = useAppDispatch();

  const [isApiProcessing, setIsApiProcessing] = useState(false);
  const [parentPANCard, setParentPANCard] = useState('');

  const addPointDataDetailsRes = useAppSelector((state: any) => state.addPointDataDetailsRes);

  const searchPatientDetailsByDocumentIdResponse = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.searchPatientDetailsByDocumentIdRes,
  );

  const [isEdit, setIsEdit] = useState(false);
  const [isEnableSubmit, setEnableSubmit] = useState(true);
  const [idCardValues, setIdCardValues] = useState([] as any[]);
  const [selectedIdProofValue, setSelectedIdProofValue] = useState<number | null>(null);
  const [govtIdTypeError, setGovtIdTypeError] = useState('');
  const idProofValueFromChild = async (idproofval: any) => {
    setSelectedIdProofValue(idproofval);
  };
  const [idValue, setIdValue] = useState('');
  const [govtIdNumberError, setGovtIdNumberError] = useState('');

  const [govtImgId, setGovtImgId] = useState('');
  const updateGovtDataStateFromChild = async (documentId: any) => {
    setGovtImgId(documentId);
    if (govtImgId !== documentId) {
      dispatch(
        addPatientDataDetails({
          patientId: '23',
          description: `VerificationDocument: PAN_Card-${parentPANCard}`,
          startDate: dayjs(String(new Date())).format('YYYY-MM-DDTHH:mm:ss'),
          patientDocumentId: String(documentId),
        } as AddPatientDataDetailsBody),
      );
    }
  };
  const [govtImageInfo, setGovtImageInfo] = useState('');

  // const getDemographicsDetailsByPtIdRes = useAppSelector(
  //   (state) => state.getDemographicsDetailsByPtId,
  // );
  useEffect(() => {
    //   getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //     ?.idType?.value !== undefined
    //     ? setSelectedIdProofValue(
    //         getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //           ?.idType?.value,
    //       )
    //     : setSelectedIdProofValue(null);
    //   getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //     ?.idNumber !== undefined
    //     ? setIdValue(
    //         getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //           ?.idNumber,
    //       )
    //     : setIdValue('');
    //   getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //     ?.supportingDocuments?.document !== undefined
    //     ? setGovtImageInfo(
    //         getDemographicsDetailsByPtIdRes?.getDemographicsDetailsByPtIdRes?.personalDetails?.idProof
    //           ?.supportingDocuments?.document,
    //       )
    //     : setGovtImageInfo('');
    // }, [getDemographicsDetailsByPtIdRes]);
    setGovtImageInfo('');
  }, []);
  // Call Govt Id type store
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getGovtIDProofStoreValue = useAppSelector((state: any) => state.govtIdProofList);
  // Get Govt. ID List
  useEffect(() => {
    if (getGovtIDProofStoreValue?.govtIdProofResponse?.govtIdTypeList !== undefined) {
      setIdCardValues(getGovtIDProofStoreValue?.govtIdProofResponse.govtIdTypeList);
    } else setIdCardValues([] as any[]);
  }, [getGovtIDProofStoreValue]);

  const [checkImgUpload, setCheckImgUpload] = useState(false);
  // Get PreviewImg Details
  const viewPreviewImageData = (passedVal: boolean) => {
    setCheckImgUpload(passedVal);
  };

  // const [delImg, setDelImg] = useState(false);
  const [delImgAction, setDelImgAction] = useState(false);

  const updateDeleteImg = (passedVal: boolean) => {
    setDelImgAction(passedVal);
  };
  // const delImgAction = (passeVal: boolean) => {
  //   setDelImg(passeVal);
  // };

  // const showDocument = () => {
  //   setDescriptionModalActive(true);
  // };
  // Call govt. image update Body
  const updateGovtIdImg = () => {
    if (delImgAction) {
      setDelImgAction(false);
      // When user delete image
      if (selectedIdProofValue === null && idValue === '') {
        setGovtIdTypeError('Please select a id card');
        setGovtIdNumberError('Please enter id card number');
      } else if (selectedIdProofValue === null && idValue !== '') {
        setGovtIdTypeError('Please select a id card');
        setGovtIdNumberError('');
      } else if (selectedIdProofValue !== null && idValue === '') {
        setGovtIdTypeError('');
        setGovtIdNumberError('Please enter id card number');
      } else {
        setGovtIdTypeError('');
        setGovtIdNumberError('');
        // const govtIdUpdateBody = {
        //   healthRecordId: patientid,
        //   govtIdNumber: idValue,
        //   govtIdType: String(selectedIdProofValue),
        //   govtIdImage: '-1',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // } as any;
        // dispatch(updateDemographicsDetailsByPatientId(govtIdUpdateBody));
      }
    } else {
      if (govtImgId !== undefined) {
        // when user add new image
        if (selectedIdProofValue === null && idValue === '') {
          setGovtIdTypeError('Please select a id card');
          setGovtIdNumberError('Please enter id card number');
        } else if (selectedIdProofValue === null && idValue !== '') {
          setGovtIdTypeError('Please select a id card');
          setGovtIdNumberError('');
        } else if (selectedIdProofValue !== null && idValue === '') {
          setGovtIdTypeError('');
          setGovtIdNumberError('Please enter id card number');
        } else {
          setGovtIdTypeError('');
          setGovtIdNumberError('');
          // const govtIdUpdateBody = {
          //   healthRecordId: patientid,
          //   govtIdNumber: idValue,
          //   govtIdType: String(selectedIdProofValue),
          //   govtIdImage: String(govtImgId),
          // } as any;
          // dispatch(updateDemographicsDetailsByPatientId(govtIdUpdateBody));
        }
      } else {
        // when user edit other details
        if (selectedIdProofValue === null && idValue === '') {
          setGovtIdTypeError('Please select a id card');
          setGovtIdNumberError('Please enter id card number');
        } else if (selectedIdProofValue === null && idValue !== '') {
          setGovtIdTypeError('Please select a id card');
          setGovtIdNumberError('');
        } else if (selectedIdProofValue !== null && idValue === '') {
          setGovtIdTypeError('');
          setGovtIdNumberError('Please enter id card number');
        } else {
          setGovtIdTypeError('');
          setGovtIdNumberError('');
          // const govtIdUpdateBody = {
          //   healthRecordId: patientid,
          //   govtIdNumber: idValue,
          //   govtIdType: String(selectedIdProofValue),
          // } as any;
          // dispatch(updateDemographicsDetailsByPatientId(govtIdUpdateBody));
        }
      }
    }
  };

  return (
    <Card>
      <CardContent>
        <Grid container direction='column' justifyContent='flex-start' alignItems='stretch'>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextField
              label="Patient's Parent PAN Card Number"
              placeholder="Enter Patient's Parent PAN Card Number"
              variant='outlined'
              size='small'
              value={parentPANCard}
              onChange={(event) => setParentPANCard(event.target.value)}
              disabled={
                searchPatientDetailsByDocumentIdResponse?.loading ||
                isApiProcessing ||
                addPointDataDetailsRes?.loading
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <MWUploader
              documentType='patient-id-Image'
              criteria='Document size should be maximum 10MB.'
              updatedDataState={updateGovtDataStateFromChild}
              title="Update Patient's Parent PAN Card"
              visibility={isEdit}
              imageUrl={govtImageInfo}
              docImg={govtImageInfo}
              deleteImgAction={delImgAction}
              previewImageData={viewPreviewImageData}
              deleteUploadedImg={updateDeleteImg}
              disabled={!parentPANCard}
              onLoadingChange={(loading) => setIsApiProcessing(loading)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
